module.exports = __webpack_public_path__ + "img/xinjin2.bf59707d.png";